// extracted by mini-css-extract-plugin
export default {"overlay":"welcome_overlay__p9RWy","main":"welcome_main__lx3kq","enter":"welcome_enter__sSmJN","goToLogin":"welcome_goToLogin__CwNL1","animation":"welcome_animation__rnKvP"};